import type { UserRolePermissions } from './userRoleService';

// ---------------------------------------------------------------------------
// Administrator — full access to everything
// ---------------------------------------------------------------------------
export const ADMINISTRATOR_DEFAULT_PERMISSIONS: UserRolePermissions = {
  reportAccessPermissions: {
    utilisationReport:         { enabled: true, viewAccess: 'all', allowExport: true },
    utilisationForecastReport: { enabled: true, viewAccess: 'all', allowExport: true },
    availableCapacityReport:   { enabled: true, viewAccess: 'all', allowExport: true },
    resourceAllocationReport:  { enabled: true, viewAccess: 'all', allowExport: true },
    projectStaffingReport:     { enabled: true, viewAccess: 'all', allowExport: true },
    benchReport:               { enabled: true, viewAccess: 'all', allowExport: true },
    auditLogReport:            { enabled: true, viewAccess: 'all', allowExport: true },
  },
  resourceDirectoryPermissions: {
    viewDirectory: true,
    viewDetails: true,
  },
  integrationsPermissions: {
    viewIntegrations: true,
    manageIntegrations: true,
  },
  companyManagementPermissions: {
    viewCompanies: true,
    manageCompanies: true,
  },
  settingsPermissions: {
    viewGeneral: true,
    viewTimezone: true,
    viewBookingTypeSetup: true,
    viewGroupSetup: true,
    viewRolesPermissions: true,
    viewUserSetup: true,
  },
  navigationPermissions: {
    viewDashboard: true,
    viewHeatmap: true,
    viewOpenDemand: true,
    viewProjects: true,
  },
};

// ---------------------------------------------------------------------------
// User — standard access for scheduling and basic reporting
// ---------------------------------------------------------------------------
export const USER_DEFAULT_PERMISSIONS: UserRolePermissions = {
  reportAccessPermissions: {
    utilisationReport:         { enabled: true,  viewAccess: 'own', allowExport: false },
    utilisationForecastReport: { enabled: false, viewAccess: 'own', allowExport: false },
    availableCapacityReport:   { enabled: false, viewAccess: 'own', allowExport: false },
    resourceAllocationReport:  { enabled: true,  viewAccess: 'own', allowExport: false },
    projectStaffingReport:     { enabled: false, viewAccess: 'own', allowExport: false },
    benchReport:               { enabled: false, viewAccess: 'own', allowExport: false },
    auditLogReport:            { enabled: false, viewAccess: 'own', allowExport: false },
  },
  resourceDirectoryPermissions: {
    viewDirectory: true,
    viewDetails: true,
  },
  integrationsPermissions: {
    viewIntegrations: false,
    manageIntegrations: false,
  },
  companyManagementPermissions: {
    viewCompanies: false,
    manageCompanies: false,
  },
  settingsPermissions: {
    viewGeneral: false,
    viewTimezone: false,
    viewBookingTypeSetup: false,
    viewGroupSetup: false,
    viewRolesPermissions: false,
    viewUserSetup: false,
  },
  navigationPermissions: {
    viewDashboard: false,
    viewHeatmap: false,
    viewOpenDemand: false,
    viewProjects: false,
  },
};

// ---------------------------------------------------------------------------
// Lookup helper — returns the default permissions for a given system role id
// IDs 1, 2 match defaultMockUserRoles in userRoleService.ts
// ---------------------------------------------------------------------------
export const DEFAULT_ROLE_PERMISSIONS_MAP: Record<number, UserRolePermissions> = {
  1: ADMINISTRATOR_DEFAULT_PERMISSIONS,
  2: USER_DEFAULT_PERMISSIONS,
};

export type DefaultRoleType = 'administrator' | 'user';

export const ROLE_TEMPLATE_LABELS: Record<DefaultRoleType, string> = {
  administrator: 'Administrator',
  user: 'User',
};
